import { createFileRoute } from '@tanstack/react-router';
import { MasterAuditoriaScreen } from '@/mobile/master/screens/MasterAuditoriaScreen';

export const Route = createFileRoute('/m/master/auditoria')({
  component: MasterAuditoriaScreen,
});
